import React, { useEffect, useState } from "react";
import { Alert, Lab } from "../../../../backend/src/types";
import {
  getAlertsCount,
  getAlertsList,
  handleHiddenAlert,
} from "../../fetch/AlertRequest";
import styles from "../../styles/modules/MainPage.module.css";
import "../../styles/sanitize.css";
import { useUser } from "../../contexts/UserContext";

interface DiscardedListProps {
  onFinish: () => void;
  isLabAdmin: boolean;
  selectedLab: Lab;
}

type DiscardedAlert = Pick<Alert, "id" | "reagent_id" | "is_resolved"> & {
  name: string;
  capacity_base: number;
  display_unit: string;
};

const DiscardedList: React.FC<DiscardedListProps> = ({
  onFinish,
  isLabAdmin,
  selectedLab,
}) => {
  const [discardedList, setDiscardedList] = useState<DiscardedAlert[]>([]);
  const { user, userLabs, setAlertCount } = useUser();

  useEffect(() => {
    loadDiscardedAlertList();
  }, [selectedLab]);

  async function loadDiscardedAlertList() {
    const result = await getAlertsList<DiscardedAlert>({
      tenant_id: selectedLab.tenant_id,
      lab_id: selectedLab.id,
      category: "discarded",
    });

    setDiscardedList(result);
    onFinish();
  }

  const handleHide = async (id: number) => {
    await handleHiddenAlert({ alertId: id });

    setDiscardedList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, is_resolved: true } : item,
      ),
    );

    if (user?.tenant_id) {
      const tenant_id = user?.tenant_id;
      const lab_ids = userLabs.map((lab) => lab.id);
      const alertCount = await getAlertsCount({ tenant_id, lab_ids });
      setAlertCount(alertCount);
    }
  };

  return (
    <div className={styles["alert-section"]}>
      <h3>廃棄一覧</h3>

      <table>
        <thead>
          <tr>
            <th>試薬名</th>
            <th>試薬ID</th>
            <th>サイズ</th>
            {isLabAdmin && <th>非表示</th>}
          </tr>
        </thead>
        <tbody>
          {discardedList.filter((alert) => !alert.is_resolved).length > 0 ? (
            discardedList
              .filter((alert) => !alert.is_resolved)
              .map((alert) => (
                <tr key={alert.id}>
                  <td>{alert.name}</td>
                  <td>{alert.reagent_id}</td>
                  <td>
                    {alert.capacity_base}
                    {alert.display_unit}
                  </td>
                  {isLabAdmin && (
                    <td>
                      <button onClick={() => handleHide(alert.id)}>
                        非表示
                      </button>
                    </td>
                  )}
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan={isLabAdmin ? 4 : 3}>
                <p className="list-none">アラートなし</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DiscardedList;
